<template>
  <div>
    <h3 class="page-heading">Add Project</h3>
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "add_story_wrapper",
  methods: {},
  beforeMount() {
    if (this.$route.path === "/newprofile/add-story") {
      this.$router.push("/newprofile/add-story/step-1");
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/v2/add_story/add_story_wrapper.vue